export default "__VITE_ASSET__BGqUMQQQ__"